import moscow from '../images/moscow.png';
import saintPetersburg from '../images/saint-petersburg.png';
import sochi from '../images/sochi.png';

export const CITIES = [
  { city: 'Сочи', image: sochi },
  { city: 'Москва', image: moscow },
  { city: 'Санкт-Петербург', image: saintPetersburg },
];
